import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sl-scatter-charts',
  templateUrl: './scatter-charts.component.html',
  styleUrls: ['./scatter-charts.component.css']
})
export class ScatterChartsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
